module.exports = __webpack_public_path__ + "nKKZ-Go6G5tXcraBGwCYdA.f3984ef63eee64cecc22.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/thana/Documents/sdc-nida-front_2024/backoffice/src/css/nKKZ-Go6G5tXcraBGwCYdA.woff2
// module id = ../../../../../src/css/nKKZ-Go6G5tXcraBGwCYdA.woff2
// module chunks = styles